var ErrorTypes;
(function (ErrorTypes) {
  ErrorTypes["INVALID_CODE"] = "INVALID_CODE";
  ErrorTypes["INVALID_MOBILE_AUTH"] = "INVALID_MOBILE_AUTH";
  ErrorTypes["NO_TOKEN"] = "NO_TOKEN";
  ErrorTypes["FALLBACK"] = "FALLBACK";
})(ErrorTypes || (ErrorTypes = {}));
export default ErrorTypes;